import { accessRole } from "../../helpers/access_role";
import ErrorAccess from "../../components/Error/Content/Access";

import IndexView from "./Index/View";
import UploadView from "./Upload/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _detail = queryParams.get("detail");

  if (_detail != null) {
    return accessRole("update") ? <UploadView /> : <ErrorAccess />;
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};

export default RouteView;

